module.exports = __webpack_public_path__ + "static/img/press0.bc09056.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press0.png
// module id = AFwS
// module chunks = 0